type TitleState = "crying" | "monologue-1" | "searching-heart" | "monologue-2";

export class TitleStateManager {
  private _state: TitleState = "crying";

  get state() {
    return this._state;
  }

  next() {
    switch (this._state) {
      case "crying":
        this._state = "monologue-1";
        return;
      case "monologue-1":
        this._state = "searching-heart";
        return;
      case "searching-heart":
        this._state = "monologue-2";
        return;
    }
  }
}
